"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var NAME = 'header2';
var Header2 = /** @class */ (function (_super) {
    __extends(Header2, _super);
    function Header2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function (node) { return 'h2'; };
        _this.textMatcher = [
            {
                matcher: /^(#{2})\s$/,
                handler: function (match) {
                    return {
                        level: match[1].length
                    };
                }
            }
        ];
        _this.attrs = {
            level: {
                default: 2
            }
        };
        _this.parseDOM = [{ tag: 'h2', attrs: { level: 2 } }];
        return _this;
    }
    return Header2;
}(core_utilities_1.Block));
exports.Header2 = Header2;
var Header2Controller = /** @class */ (function (_super) {
    __extends(Header2Controller, _super);
    function Header2Controller() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.toolbar = {
            className: 'header2',
            tooltip: 'header2'
        };
        return _this;
    }
    return Header2Controller;
}(core_utilities_1.SylController));
exports.Header2Controller = Header2Controller;
var Header2Plugin = /** @class */ (function (_super) {
    __extends(Header2Plugin, _super);
    function Header2Plugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = Header2Controller;
        _this.Schema = Header2;
        return _this;
    }
    return Header2Plugin;
}(core_utilities_1.SylPlugin));
exports.Header2Plugin = Header2Plugin;
//# sourceMappingURL=header2.js.map